var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-theme-provider',{attrs:{"dark":_vm.dark}},[_c('div',[_c('base-title',{attrs:{"size":"body-1","space":"4","title":"MULTI-PURPOSE THEME","weight":"regular"}}),_c('base-body',[_vm._v(" XXXX compornent/base/info.vueにあります。 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }